import React from 'react'
import PropTypes from 'prop-types'
import passportImg from '../../assets/img/passportLogo.svg'

class StationPassportTitle extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <div className={`station-passport-title ${this.props.className}`}>
        <span>{this.props.stationTitle}</span>
        <span className="station-passport-title__logo-container">
          <img className="passport-img" src={passportImg} alt="Passport Logo" />
        </span>
        <span>Passport</span>
      </div>
    )
  }
}

StationPassportTitle.propTypes = {
  stationTitle: PropTypes.string,
  className: PropTypes.string,
}

StationPassportTitle.defaultProps = {
  className: '',
}

export default StationPassportTitle
